import { render, staticRenderFns } from "./CbsViewInput.vue?vue&type=template&id=4eb87994&scoped=true"
import script from "./CbsViewInput.vue?vue&type=script&lang=js"
export * from "./CbsViewInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb87994",
  null
  
)

export default component.exports